import type { CommuteMode } from '../../redux/features/jobFormSlice';
import type { HomeCommuteDurations } from './fetch-home-commute';

const DEFAULT_ORDER: CommuteMode[] = ['transit', 'driving', 'cycling', 'walking'];

/** The user's preferred mode first (public transport by default), then the rest in the usual order. */
export function commuteModeOrder(preferred: CommuteMode | null | undefined): CommuteMode[] {
  const first = preferred ?? 'transit';
  return [first, ...DEFAULT_ORDER.filter((m) => m !== first)];
}

/** The one figure worth printing when there is room for only one: the first mode in preference order that actually has a duration. */
export function primaryCommute(durations: HomeCommuteDurations | null | undefined, preferred: CommuteMode | null | undefined): { mode: CommuteMode; minutes: number } | null {
  if (!durations) return null;
  for (const mode of commuteModeOrder(preferred)) {
    const minutes = durations[mode];
    if (typeof minutes === 'number' && minutes > 0) return { mode, minutes };
  }
  return null;
}
